import useSafeNetworkRequest from '@root/core/src/hooks/use-safe-network-request';
import validateTokenConfiguration from '@root/auth/src/api/validate-token/validate-token-configuration';
import { useCallback, useMemo } from '@root/vendor/react';

export default function useValidateToken(handler, handlerDeps) {
  const configuration = useMemo(validateTokenConfiguration, [validateTokenConfiguration]);
  return useSafeNetworkRequest(configuration, useCallback(handler, handlerDeps));
}
